import * as mutationTypes from './mutation-types'
import {v4 as uuid} from 'uuid'

const initialState = () => ({
    errorsUuid: null,
    confirm: {
        errors: [],
        hidePrimaryButton: false,
        hideSecondaryButton: false,
        info: '',
        infoIcon: 'info',
        infoIconColor: 'info',
        item: {},
        loading: false,
        onClose: () => {},
        onSubmit: () => {},
        primaryButtonColor: 'primary',
        primaryButtonText: 'Confirm',
        saving: false,
        secondaryButtonColor: 'secondary',
        secondaryButtonText: 'Close',
        submitKey: '',
        submitValue: '',
        text: 'Please confirm you want to do this.',
        textIcon: 'warning',
        textIconColor: 'primary',
        title: 'Confirm',
        uuid: uuid(),
        value: false
    }
})

export default (namespace) => {
    namespace = namespace
        ? `${namespace}/`
        : ''

    return {
        namespaced: true,
        state: initialState(),
        getters: {
            originalErrorsUuid: state => state.errorsUuid,
            props: (state, getters, rootState, rootGetters) => ({
                ...state.confirm,
                errors: rootGetters[`${namespace}errors/validationErrorsByUuid`](state.confirm.uuid)
            })
        },
        actions: {
            closeConfirm: async ({commit, dispatch, getters}, data) => {
                await getters.props.onClose(data)
                await dispatch('setConfirmLoading')
                await dispatch('resetConfirm')
                commit(mutationTypes.HIDE_CONFIRM)
                dispatch(`${namespace}errors/setErrorsUuid`, getters.originalErrorsUuid, {root: true})
            },
            resetConfirm: ({commit}) => commit(mutationTypes.RESET_CONFIRM),
            setConfirmErrors: ({commit}, errors) => commit(mutationTypes.SET_CONFIRM_PROPS, {errors}),
            setConfirmLoading: ({commit}, loading = true) => commit(mutationTypes.SET_CONFIRM_PROPS, {loading, value: true}),
            setConfirmSaving: ({commit}, saving = true) => commit(mutationTypes.SET_CONFIRM_PROPS, {saving, value: true}),
            showConfirm: ({commit, dispatch, getters, rootGetters}, data) => {
                commit(mutationTypes.SET_ERRORS_UUID, rootGetters[`${namespace}errors/errorsUuid`])
                dispatch(`${namespace}errors/setErrorsUuid`, getters.props.uuid, {root: true})
                commit(mutationTypes.SET_CONFIRM_PROPS, {value: true, ...data})
            },
            showRemoveConfirm: ({commit, dispatch}, data) => dispatch('showConfirm', {
                value: true,
                title: 'Remove',
                text: 'Are you sure you want to remove this item?',
                textIconColor: 'error',
                primaryButtonColor: 'error',
                primaryButtonText: 'remove',
                submitKey: 'uuid',
                ...data
            }),
            submitConfirm: async ({commit, dispatch, getters, rootGetters}, data) => {
                await getters.props.onSubmit(data)
            }
        },
        mutations: {
            [mutationTypes.HIDE_CONFIRM] (state) {
                state.confirm.loading = true
                state.confirm.value = false
            },
            [mutationTypes.RESET_CONFIRM] (state) {
                Object.assign(state, initialState())
            },
            [mutationTypes.SET_ERRORS_UUID] (state, uuid) {
                state.errorsUuid = uuid
            },
            [mutationTypes.SET_CONFIRM_PROPS] (state, data) {
                state.confirm = {...state.confirm, ...data}
            }
        }
    }
}
